import GenerateReport from "./GenerateReport.js";

const configuration = () => {
      return (
        <div style={{minHeight:'81vh'}}>
          <h1>Configuration</h1>
          <p>On clicking this button the Zoho data will be sync to Vector Database <GenerateReport /></p>
        </div>
      );
}
export default configuration;
